import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap } from "rxjs";
import { Appointment, AppointmentAvailabilityResult, AppointmentSlotRequest } from "./iappointment";
import { UserAvalibility } from "../user/iusers";

@Injectable({ providedIn: 'root' })
export class AppointmentService {

    private _avalibility: BehaviorSubject<UserAvalibility | null> = new BehaviorSubject<UserAvalibility | null>(null);
    private _appointment: BehaviorSubject<Appointment | null> = new BehaviorSubject<Appointment | null>(null);
    private _appointments: BehaviorSubject<Appointment[]> = new BehaviorSubject<Appointment[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }


    get appointment$(): Observable<Appointment | null> {
        return this._appointment.asObservable();
    }

    get appointments$(): Observable<Appointment[]> {
        return this._appointments.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }

    getUserAvalibility(id: number, day: string) {
        return this._httpClient.get<BaseRespone<UserAvalibility>>(`${environment.baseURl}/User/${id}/${day}/availability`).pipe(
            tap((response) => {
                this._avalibility.next(response.result);
            }),
            catchError((error) => {
                console.error('Error to fetching data:', error);
                throw error;
            })
        );
    }

    getAppointmentSlot(appointmentSlot: AppointmentSlotRequest): Observable<BaseRespone<AppointmentAvailabilityResult>> {
        return this._httpClient.post<BaseRespone<any>>(`${environment.baseURl}/Appointment/get-available-slots`, appointmentSlot).pipe(
            tap((response) => {
                this._appointments.next(response.result.timeSlots.appointment || []);
            }),
            catchError((error) => {
                return of(error.error);
            })
        );
    }

    createAppointment(appointment: Appointment): Observable<BaseRespone<Appointment>> {
        return this._httpClient.post<BaseRespone<Appointment>>(`${environment.baseURl}/Appointment`, appointment).pipe(
            tap((response) => {
                this._appointment.next(response.result);
            }),
            catchError((error) => {
                return of(error.error);
            })
        );
    }

    updateAppointment(appointment: Appointment): Observable<BaseRespone<Appointment>> {
        return this._httpClient.put<BaseRespone<Appointment>>(`${environment.baseURl}/Appointment`, appointment).pipe(
            tap((response) => {
                this._appointment.next(response.result);
            }),
            catchError((error) => {
                return of(error.error);
            })
        );
    }

    getAppointmentById(id: number): Observable<BaseRespone<Appointment>> {
        return this._httpClient.get<BaseRespone<Appointment>>(`${environment.baseURl}/Appointment/${id}`).pipe(
            tap((response) => {
                this._appointment.next(response.result);
            }),
            catchError((error) => {
                return of(error.error);
            }
        ));
    }

    deleteAppointment(id: number): Observable<BaseRespone<boolean>> {
        return this.appointments$.pipe(
            take(1),
            switchMap(appointment =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/Appointment/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const updatedappointment = appointment.filter(item => item.id !== id);
                            this._appointments.next(updatedappointment);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                return of(error.error);
            })
        );
    }

    getBookedDays(doctorId: number, month: number, year: number): Observable<BaseRespone<Date[]>> {
        const payload = { doctorId, month, year };

        return this._httpClient.post<BaseRespone<Date[]>>(
            `${environment.baseURl}/Appointment/BookedDays`,
            payload
        ).pipe(
            tap((response) => {
                return response;
            }),
            catchError((error) => {
                console.error('Error fetching booked days:', error);
                return of(error.error);
            })
        );
    }
}
